'use strict';
import axios from "axios";

export default {
    state: {
        deliveryCompanies: [],
        calculateResults: [],
        calcValidationErrors: [],
    },
    mutations: {
        setterDeliveryCompanies(state, data) {
            state.deliveryCompanies = data;
        },
        setterCalculateResults(state, result) {
            if (Array.isArray(result)) {
                state.calculateResults = [...state.calculateResults, ...result];
            } else {
                state.calculateResults.push(result);
            }
        },
        setValidationErrors(state, errors) {
            state.calcValidationErrors = errors;
        },
        clearCalculateResults(state) {
            state.calculateResults = [];
        },
        clearValidationErrors(state) {
            state.calcValidationErrors = [];
        }
    },
    getters: {
        getDeliveryCompanies: state => state.deliveryCompanies,
        getCalculateResults: state => state.calculateResults,
        getValidationErrors: state => state.calcValidationErrors,
    },
    actions: {
        async getDeliveryCompaniesForParcel(context, payload) {
            const url = `?parcel_id=${payload.parcelId}&address_id=${payload.addressId}`;
            const response = await axios.get(`/user-dashboard/packages/parcel-delivery-companies${url}`);
            context.commit('setterDeliveryCompanies', response.data);
        },
        async getCalculateResults(context, data) {
            const params = new URLSearchParams({
                ...data,
                insurance: data.insurance ? 'on' : '',
            }).toString();

            const source = new EventSource(`/calculate-rate?${params}`);

            const processMessages = new Promise((resolve, reject) => {
                source.onmessage = (event) => {
                    try {
                        const result = JSON.parse(event.data);
                        context.commit('setterCalculateResults', result);
                    } catch (e) {
                        console.error("Failed to parse result:", e);
                    }
                };

                source.addEventListener('complete', () => {
                    source.close();
                    resolve();
                });

                source.addEventListener('error', (event) => {
                    source.close();
                    try {
                        const parsed = event?.data ? JSON.parse(event.data) : {};
                        if (Array.isArray(parsed.errors)) {
                            // A message from the backend the user has to read, such as
                            // "we do not deliver to <country>". Field errors come as an object.
                            const error = new Error(parsed.errors.join(' '));
                            error.displayable = true;
                            reject(error);
                        } else if (parsed.errors) {
                            context.commit('setValidationErrors', parsed.errors);
                            reject(new Error("Validation error"));
                        } else {
                            reject(new Error("Unknown SSE error"));
                        }
                    } catch (err) {
                        console.error("Error parsing SSE error event:", err);
                        reject(new Error("Error parsing SSE response"));
                    }
                });
            });

            try {
                await processMessages;
            } catch (error) {
                throw error;
            }
        },
    },
};
